import { AlertDialog, AlertDialogBody, AlertDialogCloseButton, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, useDisclosure } from '@chakra-ui/react'
import { isValidVINLength } from 'BrokerTsLib/src/Utils/vin'
import { useEffect, useRef } from 'react'

interface InvalidVinWarningProps {
  vin: string
  /** Whether the warning can be shown eg. after the user has finished entering the VIN */
  canShow?: boolean
}

export const InvalidVinWarning = ({ vin, canShow }: InvalidVinWarningProps) => {
  const okRef = useRef<HTMLButtonElement>(null)
  const { onClose, isOpen, onOpen } = useDisclosure()

  useEffect(() => {
    if (!isValidVINLength(vin) && vin !== '' && canShow) {
      onOpen()
    }
  }, [vin, onOpen, canShow])
    
  return <AlertDialog
    motionPreset='slideInBottom'
    leastDestructiveRef={okRef}
    onClose={onClose}
    isOpen={isOpen}
    isCentered
  >
    <AlertDialogOverlay />

    <AlertDialogContent>
      <AlertDialogHeader>Kontrola VIN</AlertDialogHeader>
      <AlertDialogCloseButton />
      <AlertDialogBody>
        Zadané VIN nemá 17 znaků. Prosím zkontrolujte VIN vozidla.
      </AlertDialogBody>
      <AlertDialogFooter>
        <Button ref={okRef} onClick={onClose}>
          Ok
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
}